var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"Loader",class:_vm.$vuetify.theme.dark? 'Loader__dark' :'',style:(_vm.loaderStyle)},[_c('div',{staticClass:"loader-1 center"},[_c('span')])])])}
var staticRenderFns = []

export { render, staticRenderFns }